import { Action } from '../../types';

export enum Actions {
    SET_EQUIPMENT_SELECTED_TAB = 'EQUIPMENT_PROFILE_SET_SELECTED_TAB',
}

export const setEquipmentSelectedTab = (index: number): Action => {
    return {
        type: Actions.SET_EQUIPMENT_SELECTED_TAB,
        payload: index,
        error: null,
    };
};
